"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ExpandCollapseControl = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "ExpandCollapse__ExpandCollapseControl",
  componentId: "components-web__sc-1l2mmq7-0"
})({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flex: 1,
  justifyContent: 'flex-start'
});
const ExpandCollapseIconContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "ExpandCollapse__ExpandCollapseIconContainer",
  componentId: "components-web__sc-1l2mmq7-1"
})(_ref => {
  let {
    tokens
  } = _ref;
  return {
    alignItems: tokens.expandIconContainerAlignItems,
    justifyContent: tokens.expandIconContainerJustifyContent,
    marginLeft: `${tokens.expandIconContainerMarginY}px`,
    marginRight: `${tokens.expandIconContainerMarginY}px`,
    width: tokens.expandIconContainerWidth
  };
});
const ExpandCollapseTitle = /*#__PURE__*/_styledComponents.default.h4.withConfig({
  displayName: "ExpandCollapse__ExpandCollapseTitle",
  componentId: "components-web__sc-1l2mmq7-2"
})(_ref2 => {
  let {
    tokens
  } = _ref2;
  return {
    color: tokens.expandTitleColor,
    fontFamily: `${tokens.expandTitleFontName}${tokens.expandTitleFontWeight}normal`,
    fontSize: tokens.expandTitleFontSize,
    lineHeight: tokens.expandTitleLineHeight,
    margin: `${tokens.expandTitleMarginX}px ${tokens.expandTitleMarginY}px`
  };
});
const getIconButtonTokens = _ref3 => {
  let {
    icon,
    iconBackgroundColor,
    iconBorderColor,
    iconColor,
    iconOuterBorderColor,
    iconOuterBorderGap,
    iconOuterBorderWidth
  } = _ref3;
  return {
    icon,
    backgroundColor: iconBackgroundColor,
    borderColor: iconBorderColor,
    iconColor,
    outerBorderColor: iconOuterBorderColor,
    outerBorderGap: iconOuterBorderGap,
    outerBorderWidth: iconOuterBorderWidth
  };
};
const ExpandCollapse = /*#__PURE__*/_react.default.forwardRef((_ref4, ref) => {
  let {
    children,
    collapseTitle,
    expandTitle = collapseTitle,
    expandLabel,
    collapseLabel
  } = _ref4;
  const getTokens = (0, _componentsBase.useThemeTokensCallback)('TermsAndConditions', {}, {});
  const {
    expandBaseBorderWidth,
    expandContentPaddingBottom,
    expandContentPaddingLeft,
    expandContentPaddingRight,
    expandContentPaddingTop,
    contentBorderColor,
    contentMarginBottom,
    headerBackgroundColor,
    expandTitlePaddingLeft,
    expandTitleBorder,
    expandTitleBorderColor,
    expandTitleUnderline
  } = getTokens();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.ExpandCollapse, {
    tokens: {
      borderWidth: expandBaseBorderWidth
    },
    children: expandProps => /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.ExpandCollapse.Panel, {
      ...expandProps,
      panelId: "ExpandCollapsePanel",
      controlTokens: {
        icon: null,
        backgroundColor: 'transparent',
        paddingLeft: expandTitlePaddingLeft,
        borderColor: expandTitleBorderColor,
        borderWidth: expandTitleBorder,
        textLine: expandTitleUnderline
      }
      // TODO refactor
      // eslint-disable-next-line react/no-unstable-nested-components
      ,
      control: pressableState => {
        const {
          expanded
        } = pressableState || {};
        const iconTokens = getIconButtonTokens(getTokens(pressableState || {}));
        const label = expanded ? collapseLabel : expandLabel;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ExpandCollapseControl, {
          ref: ref,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ExpandCollapseIconContainer, {
            tokens: getTokens(),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.IconButton, {
              variant: {
                size: 'small'
              },
              tokens: iconTokens,
              focusable: false,
              accessibilityLabel: label,
              accessibilityRole: "none"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ExpandCollapseTitle, {
            tokens: getTokens(),
            children: expanded ? expandTitle : collapseTitle
          })]
        });
      },
      tokens: {
        contentPaddingBottom: expandContentPaddingBottom,
        contentPaddingLeft: expandContentPaddingLeft,
        contentPaddingRight: expandContentPaddingRight,
        contentPaddingTop: expandContentPaddingTop,
        contentPanelBackgroundColor: headerBackgroundColor,
        borderColor: contentBorderColor,
        marginBottom: contentMarginBottom
      },
      children: children
    })
  });
});
ExpandCollapse.displayName = 'ExpandCollapse';
ExpandCollapse.propTypes = {
  children: _propTypes.default.node.isRequired,
  collapseTitle: _propTypes.default.string.isRequired,
  expandTitle: _propTypes.default.string,
  collapseLabel: _propTypes.default.string,
  expandLabel: _propTypes.default.string
};
var _default = exports.default = ExpandCollapse;